import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern street lamp: concrete-ringed base, tapered pole to ~4 m, a two-segment
// curved-look arm reaching toward +Z and a lamp head with a glowing underside.
const BLACK = "#2e2e30";
const CONCRETE = "#9a9a94";
const GLOW = "#f2efdc";

export const streetlight = defineModel({
  id: "streetlight",
  batchId: "modern",
  name: "Streetlight",
  tags: ["modern", "outdoor", "street", "lighting", "lamp"],
  summary: "A matte-black street lamp with a curved arm over the road.",
  description:
    "A contemporary street lamp of the Modern Living kit: a concrete-ringed " +
    "base, a tapered matte-black pole rising to 4 m, a two-segment arm curving " +
    "0.8 m toward +Z and a boxy lamp head with a glow-white underside panel. " +
    "Place at the kerb with the arm over the road.",
  tiles: { w: 1, h: 1 },
  footprint: 2.2,
  parts(): Part[] {
    return [
      // Concrete ring base.
      {
        geometry: new THREE.CylinderGeometry(0.16, 0.19, 0.12, 10),
        color: CONCRETE,
        position: [0, 0.06, 0],
      },
      // Tapered pole.
      {
        geometry: new THREE.CylinderGeometry(0.045, 0.08, 4.0, 8),
        color: BLACK,
        position: [0, 2.0, 0],
      },
      // Curved-look arm: two angled segments toward +Z.
      {
        geometry: new THREE.BoxGeometry(0.07, 0.07, 0.52),
        color: BLACK,
        position: [0, 4.06, 0.22],
        rotation: [-0.42, 0, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.06, 0.06, 0.42),
        color: BLACK,
        position: [0, 4.22, 0.62],
        rotation: [-0.1, 0, 0],
      },
      // Lamp head box.
      {
        geometry: new THREE.BoxGeometry(0.24, 0.12, 0.44),
        color: BLACK,
        position: [0, 4.24, 0.82],
      },
      // Glow-white underside panel.
      {
        geometry: new THREE.BoxGeometry(0.18, 0.02, 0.36),
        color: GLOW,
        position: [0, 4.17, 0.82],
      },
    ];
  },
  animations: [],
});
